import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { DismissableTooltip } from "@faire/web--source/slate/Tooltip";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackFlashSalesSaleAnnouncementTooltipClick } from "@faire/web-api--source/events/flashSales/click/saleAnnouncementTooltip";
import { trackFlashSalesSaleAnnouncementTooltipDismiss } from "@faire/web-api--source/events/flashSales/dismiss/saleAnnouncementTooltip";
import { trackFlashSalesSaleAnnouncementTooltipView } from "@faire/web-api--source/events/flashSales/view/saleAnnouncementTooltip";
import { SALE_ANNOUNCEMENT_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SALE_ANNOUNCEMENT_DISMISSED";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import React from "react";
import styled from "styled-components";
import { useShouldShowSaleAnnouncementNudge } from "@faire/retailer/components/Header/desktop/SaleAnnouncementNudge/useShouldShowSaleAnnouncementNudge";
import { useSettingSalesHubPowerUsers } from "@faire/retailer/settings/useSettingSalesHubPowerUsers";
export var SaleAnnouncementTooltip = function() {
    var shouldShowTooltip = useShouldShowSaleAnnouncementNudge();
    var viewRef = useDoActionWhenVisible(trackFlashSalesSaleAnnouncementTooltipView);
    var _useMilestone = useMilestone(SALE_ANNOUNCEMENT_DISMISSED), dismissSaleAnnouncement = _useMilestone.setHasOccurred;
    var tooltipContent = useGetTooltipContent();
    var handleDismiss = function() {
        if (shouldShowTooltip) {
            trackFlashSalesSaleAnnouncementTooltipDismiss();
            dismissSaleAnnouncement();
        }
    };
    var handleClick = function() {
        trackFlashSalesSaleAnnouncementTooltipClick();
        dismissSaleAnnouncement();
    };
    if (!shouldShowTooltip) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ClickOutside, {
        onClickOutside: handleDismiss,
        children: /*#__PURE__*/ _jsx(StyledTooltip, {
            position: "bottom",
            targetNode: /*#__PURE__*/ _jsx("div", {
                ref: viewRef
            }),
            onDismiss: handleDismiss,
            contents: tooltipContent,
            action: /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                tertiaryColor: Core.text.inverse,
                target: "_blank",
                linkTo: c1CategoryPath("sale"),
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "ODd8bB",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shop Sale"
                        }
                    ]
                })
            })
        })
    });
};
var useGetTooltipContent = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isSalesHubPowerUser = useSettingSalesHubPowerUsers();
    if (isSalesHubPowerUser) {
        return [
            {
                title: strictLocalize({
                    id: "SE1FXV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "New! Find even more deals in Sale"
                        }
                    ]
                }),
                body: strictLocalize({
                    id: "8WiNzV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "In addition to flash deals, the deepest discounts on Faire, you\u2019ll now find all brand promotions in Sale."
                        }
                    ]
                })
            }
        ];
    }
    return [
        {
            title: strictLocalize({
                id: "+MnV+p",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sale got an upgrade!"
                    }
                ]
            }),
            body: strictLocalize({
                id: "DO07VR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Explore all brand promotions and our flash deals, the deepest discounts on Faire. Go to the Sale tab to start saving."
                    }
                ]
            })
        }
    ];
};
var StyledTooltip = styled(DismissableTooltip).withConfig({
    componentId: "sc-327c8837-0"
})([
    "position:absolute;bottom:10px;left:0;right:0;"
]);
